// import config from "@/config";
import tool from "@/utils/tool";
import api from "@/api";

export default {
	namespaced: true,
	state: {
		Menu: tool.data.get("MENU"),
	},
	mutations: {
		SAVE_MENU(state, data) {
			state.Menu = data;
			tool.data.set("MENU", data);
		},
		clearMenu(state) {
			state.Menu = [];
			tool.data.remove("MENU");
		},
	},
	actions: {
		async ApiGetMenu({ commit }) {
			let res = await api.system.account.menu.post();
			if (res?.code === 1) {
				commit("SAVE_MENU", res.data);
			}
		},
	},
	getters: {
		GetMenu(state) {
			return state.Menu || {};
		},
	},
};
